import { IMensagem, ITipoMensagem } from "../interfaces/IMensagens";
import { INotificacaoSistema } from "../interfaces/INotificacaoSistema";
import api from "./Api";
import Swal from 'sweetalert2';

class MensagensService {

  async listarMensagensSistema(): Promise<INotificacaoSistema[]> {
    const { data: result } = await api.get<INotificacaoSistema[]>('MensagemSistema');
    return result;
  }

  async visualizarMensagem(id: number): Promise<void> {
    await api.post(`MensagemSistema/${id}`);
  }

  async visualizarTodas(): Promise<void> {
    await api.post('MensagemSistema');
  }

  async obterTodos(funcaoSucesso?: (data: IMensagem[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {

      const { data: result } = await api.get<IMensagem[]>('Mensagem');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async obterTodosTipos(funcaoSucesso?: (data: ITipoMensagem[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<ITipoMensagem[]>('TipoMensagem');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async obterPorId(id: number, funcaoSucesso?: (data: IMensagem) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IMensagem>(`Mensagem/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async criar(parametro: IMensagem, funcaoSucesso?: (data: IMensagem) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post('Mensagem', parametro);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async atualizar(parametro: IMensagem, funcaoSucesso?: (data: IMensagem) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.put(`Mensagem/${parametro.id}`, parametro);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.delete(`Mensagem/${id}`);

      funcaoSucesso && funcaoSucesso();

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }
}

export default new MensagensService();